import { Loading } from 'components/loading/loading'
import { useAuth } from 'hooks/useAuth'
import { useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'

export function VerifyMagicLink() {
  const { verifyMagicLink } = useAuth()
  const [searchParams] = useSearchParams()

  useEffect(() => {
    const token = searchParams.get('token')
    const email = searchParams.get('email')
    const session = searchParams.get('session')

    if (token && email && session) {
      verifyMagicLink(email, token, session)
    }
  }, [searchParams, verifyMagicLink])

  return <Loading size="xl" />
}
